import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { fetchRegions } from '../api';
import SearchBar from './SearchBar';

const Header = () => {
    const navigate = useNavigate();
    const [regions, setRegions] = useState([]);
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadRegions();
    }, []);

    const loadRegions = async () => {
        try {
            setLoading(true);
            const response = await fetchRegions();
            // Проверяем структуру ответа
            const regionsData = Array.isArray(response) ? response : 
                              response.data ? response.data : [];
            setRegions(regionsData);
        } catch (err) {
            console.error('Error loading regions:', err);
            setError('Ошибка при загрузке регионов');
            setRegions([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (searchParams) => {
        const params = new URLSearchParams();
        
        if (searchParams.region) {
            params.set('region', searchParams.region);
        }
        if (searchParams.type) {
            params.set('type', searchParams.type);
        }
        if (searchParams.query) {
            params.set('query', searchParams.query);
        }

        navigate(`/?${params.toString()}`);
        setIsSearchVisible(false);
    };

    return (
        <header className="header">
            <div className="container">
                <div className="header-content">
                    <Link to="/" className="header-logo">
                        <h1>IF Travel</h1>
                        <span className="header-tagline">Открой для себя Россию</span>
                    </Link>
                    <nav className="header-nav">
                        <Link to="/" className="btn btn-primary">Главная</Link>
                        <button 
                            className="btn btn-outline"
                            onClick={() => setIsSearchVisible(!isSearchVisible)}
                        >
                            <span className="icon">🔍</span>
                            Поиск
                        </button>
                    </nav>
                </div>
                {isSearchVisible && (
                    <div className="header-search">
                        <SearchBar onSearch={handleSearch} />
                    </div>
                )}
                <div className="header-regions">
                    <div className="regions-list">
                        {!loading && !error && regions.length > 0 ? (
                            regions.map((region) => (
                                <Link 
                                    key={region.id} 
                                    to={`/region/${region.id}`}
                                    className="region-link"
                                >
                                    {region.name}
                                </Link>
                            ))
                        ) : (
                            <span className="regions-loading">
                                {loading ? 'Загрузка регионов...' : 'Нет доступных регионов'}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;